import React from "react";

export const Description = ({ desc }) => (
  <li className="timeline-list-item">{desc}</li>
);